export const messageHandler = (messageData, stateUpdate, secondaryCallback) => {
  console.log("MessageHandler", messageData, stateUpdate, secondaryCallback);
  
  stateUpdate(messageData);

}